export class StringTool {

    static capitalizeFirstLetter(string: string) {
        return `${string.charAt(0).toUpperCase()}${string.slice(1)}`;
    }

    static uncapitalizeFirstLetter(string: string) {
        return `${string.charAt(0).toLowerCase()}${string.slice(1)}`;
    }

    static isNotNullOrEmpty(string: string) {
        return string && string !== undefined && string !== '';
    }
}
